import React from "react"
import PlaceImages from "../PlaceImages"
import { PCViewRoot } from "../Common/PCViewContext"

const PlaceImagesPage = (props) => {
  return (
    <PCViewRoot>
      <PlaceImages {...props} />
    </PCViewRoot>
  )
}
export default PlaceImagesPage
